/* eslint-disable no-unused-vars */
import { CaptionText, H4, P1, P2, P3 } from '../../../styles/FontStyles';
import { Flexed } from '../../../styles/GlobalComponents';
import { color } from '../../../styles/GlobalStyles';
import { BoxBig, HubImage, Td, Tr } from '../Portfolio.styled';

import moment from 'moment';
import { USDT } from '../../../helpers/helperFunctions';
import { Responsive } from '../../../styles/stylesStyled';

import Spinner from '../../../components/common/Spinner';

export const VipItem = ({ item }: { item: any }) => {
  return (
    <>
      <BoxBig relative>
        <HubImage image={item.product.imageUrl}>
          <H4 color={color.colors.neutral0}>{item.product.name}</H4>
        </HubImage>
        <div>
          <div>
            <div
              style={{
                position: 'absolute',
                left: '50%',
                right: '50%',
                transform: 'translate(-50%, -50%)'
              }}>
              <Spinner />
            </div>

            <Tr style={{ cursor: 'pointer' }}>
              <Td w='20%' wSM='50%'>
                <CaptionText caps bold color={color.colors.neutral500} mb='10'>
                  PRICE
                </CaptionText>
                <P1 bold flex alignEnd gap='5px'>
                  {item.price} <P3 mb='3'>{USDT}</P3>
                </P1>
              </Td>

              <Td w='20%' wSM='50%'>
                <CaptionText caps bold color={color.colors.neutral500} mb='10'>
                  DATE OF PURCHASE
                </CaptionText>
                <P1 bold>{moment(item?.dateCreated).format('DD MMM YYYY')}</P1>
              </Td>
              <Td w='20%' wSM='50%'></Td>
              <Td w='20%' wSM='50%'></Td>
              <Td w='20%' wSM='50%'></Td>
            </Tr>
          </div>
          <Flexed column gap='30px'>
            <Responsive style={{ margin: '24px 0' }} between>
              <Flexed mbSM='20' rowSM>
                <P3 caps bold color={color.colors.secondary100} mr='60'>
                  VIP DETAILS
                </P3>
                <P3 flex color={color.colors.secondary100} mr='60'>
                  ORDER ID:{' '}
                  <P3 bold ml='2' color={color.colors.secondary100}>
                    {item?.id}
                  </P3>
                </P3>
              </Flexed>
            </Responsive>
          </Flexed>
        </div>
      </BoxBig>
    </>
  );
};
